import React from 'react'
import { CustomTooltip } from '../CustomTooltip/CustomTooltip'
import './buttons.css'
export const ButtonWhiteTwo = ({ children, onClick, textTooltip, idTargetTooltip, placementTooltip, className = '', withTooltip = false, disabled = false, type = 'button' }) => {
    return (
        <>
            {withTooltip ? <CustomTooltip placement={placementTooltip} text={textTooltip} target={idTargetTooltip} /> : null}
            <div id={idTargetTooltip} className='w-100'>
                <button
                    onClick={onClick}
                    className={`btn btn-white-gd ${className}`}
                    type={type}
                    disabled={disabled}
                >
                    {children}
                </button>
            </div>
        </>
    )
}
